import React, { useState, useEffect, useRef, Fragment } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ImageWrapper from "./ImageWrapper";
import ZoomPanel from "./ZoomPanel";
export const PID_IMAGE_ID = "pid-image";

function PIDImageContainer({
  pidFile,
  isolationMarkup,
  selectedIsolationMarkup,
  onIsolationMarkupChange,
}) {
  const [scale, setScale] = useState(0.7);
  const transformWrapperRef = useRef(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    if (
      isolationMarkup &&
      selectedIsolationMarkup &&
      transformWrapperRef.current &&
      isImageLoaded
    ) {
      const { setTransform } = transformWrapperRef.current;
      const { wrapperComponent } = transformWrapperRef.current.instance;
      const imageElement = document.getElementById(PID_IMAGE_ID);

      if (wrapperComponent && imageElement) {
        const { clientWidth, clientHeight } = wrapperComponent;
        const currentScale = scale;

        const {
          naturalWidth,
          naturalHeight,
          width: renderedWidth,
          height: renderedHeight,
        } = imageElement;

        const renderScale = renderedWidth / naturalWidth;

        const selectedAnnotationX = parseFloat(selectedIsolationMarkup.x);
        const selectedAnnotationY = parseFloat(selectedIsolationMarkup.y);

        const annotationWidth = selectedIsolationMarkup.template_width || 0;
        const annotationHeight = selectedIsolationMarkup.template_height || 0;

        const annotationNaturalCenterX =
          selectedAnnotationX + annotationWidth / 2;
        const annotationNaturalCenterY =
          selectedAnnotationY + annotationHeight / 2;

        const contentDiv = imageElement.parentElement.parentElement;
        const offsetX = (contentDiv.clientWidth - renderedWidth) / 2;
        const offsetY = (contentDiv.clientHeight - renderedHeight) / 2;

        const annotationRenderedCenterX =
          annotationNaturalCenterX * renderScale + offsetX;
        const annotationRenderedCenterY =
          annotationNaturalCenterY * renderScale + offsetY;

        const newX = clientWidth / 2 - annotationRenderedCenterX * currentScale;
        const newY =
          clientHeight / 2 - annotationRenderedCenterY * currentScale;

        setTransform(newX, newY, currentScale, 300, "easeOut");
      }
    }
  }, [isImageLoaded, isolationMarkup, selectedIsolationMarkup]);

  return (
    <TransformWrapper
      initialScale={0.7}
      minScale={0.7}
      maxScale={16}
      wheel={{ step: 2 }}
      pinch={{ step: 0.6 }}
      centerOnInit={true}
      onTransformed={(_, state) => {
        setScale(state.scale);
      }}
      ref={transformWrapperRef}
      wrapperStyle={{
        width: "100%",
        height: "100%",
      }}>
      {({ zoomIn, zoomOut, resetTransform }) => {
        return (
          <Fragment>
            <TransformComponent
              wrapperStyle={{
                width: "100%",
                height: "100%",
                margin: "auto",
              }}
              contentStyle={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // width: "100%",
                // height: "100%",
              }}>
              {pidFile && (
                <ImageWrapper
                  selectedPIDMarkup={selectedIsolationMarkup}
                  annotations={isolationMarkup?.annotations || []}
                  scale={scale}
                  PID_IMAGE_ID={PID_IMAGE_ID}>
                  <img
                    id={PID_IMAGE_ID}
                    src={pidFile.file_url}
                    alt="PID Diagram"
                    style={{
                      // maxWidth: "100%",
                      // maxHeight: "100%",
                      maxWidth: "100vw",
                      maxHeight: "100vh",
                      objectFit: "contain",
                    }}
                    onLoad={() => {
                      setIsImageLoaded(true);
                    }}
                  />
                </ImageWrapper>
              )}
            </TransformComponent>
            <ZoomPanel
              scale={scale}
              onZoomIn={zoomIn}
              onZoomOut={zoomOut}
              onReset={resetTransform}
              isolationMarkup={isolationMarkup}
              onIsolationMarkupChange={onIsolationMarkupChange}
            />
          </Fragment>
        );
      }}
    </TransformWrapper>
  );
}

export default PIDImageContainer;
